module.exports = __webpack_public_path__ + "static/media/run-buddy.b870d8eb.png";